export type DashboardFilterValue = string | number
export type DashboardStatusLabel = [string, number]

export function shouldResetDashboardFunctionForStandort(functionId: DashboardFilterValue) {
  return functionId !== "all" && functionId !== "own"
}

export function dashboardChartParams(standortId: DashboardFilterValue, functionId: DashboardFilterValue) {
  return {
    standort_id: standortId,
    function_id: functionId,
  }
}

export function dashboardDrilldownParams(
  standortId: DashboardFilterValue,
  functionId: DashboardFilterValue,
  extra: Record<string, unknown> = {},
) {
  return {
    ...Object.fromEntries(Object.entries(extra).flatMap(([key, value]) => {
      const normalized = Array.isArray(value) ? value.filter(v => v != null && v !== "") : value
      return normalized == null || normalized === "" || (Array.isArray(normalized) && !normalized.length)
        ? [] : [[key, normalized]]
    })),
    dashboard_standort_id: standortId,
    dashboard_function_id: functionId,
  }
}

export function dashboardStatusId(labels: DashboardStatusLabel[], label: string) {
  return labels.find(([candidate]) => candidate === label)?.[1]
}

export function dashboardSelectionKey(type: unknown, aspect: unknown, status: unknown, standort: DashboardFilterValue, funktion: DashboardFilterValue) {
  return JSON.stringify([type, aspect ?? null, status ?? null, standort, funktion])
}

export function dashboardChartOptions(name: string, title: string, onSelect: (name: string, points: any[], chart: any) => void) {
  return {
    plugins: { title: { display: true, text: title, font: { size: 24, weight: "bold" as const } } },
    onClick: (_event: unknown, points: any[], chart: any) => {
      if (points.length) onSelect(name, points, chart)
    },
    onHover: (_event: unknown, points: any[], chart: any) => {
      chart.canvas.style.cursor = points.length ? "pointer" : "default"
    },
  }
}
